import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('gorgias'),
  titleToNamespace: true,
  avatarPath: avatars.gorgias,
  logoPath: logos.gorgias,
  hasConnectionStatus: false
});
